module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "viewContainer"
  }, [(_vm.isBanner) ? _c('div', [_c('div', {
    staticClass: "main_container"
  }, [_c('div', {
    staticClass: "fuji",
    on: {
      "click": function($event) {
        _vm.show3 = !_vm.show3
      }
    }
  }, [_c('div', {
    staticClass: "goodslist1"
  }, [_c('span', {
    staticStyle: {
      "margin-left": "20px",
      "margin-top": "5px"
    }
  }, [_vm._v("搜索/查询")]), _vm._v(" "), _c('span', {
    staticClass: "divReset",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.fnReset($event)
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/img/Reset.png"),
      "alt": ""
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "sanjiao",
    staticStyle: {
      "position": "absolute",
      "right": "0",
      "top": "-10px"
    }
  })]), _vm._v(" "), _c('el-collapse-transition', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show3),
      expression: "show3"
    }]
  }, [_c('el-form', {
    staticClass: "findform",
    attrs: {
      "model": _vm.filters
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "display": "flex",
      "width": "20%"
    },
    attrs: {
      "label": "关键词语："
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "90%"
    },
    attrs: {
      "placeholder": "请输入员工账号/姓名/手机号"
    },
    model: {
      value: (_vm.filters.name),
      callback: function($$v) {
        _vm.$set(_vm.filters, "name", $$v)
      },
      expression: "filters.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "select",
    staticStyle: {
      "display": "flex",
      "width": "20%"
    },
    attrs: {
      "label": "角色："
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "90%"
    },
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.filters.roles),
      callback: function($$v) {
        _vm.$set(_vm.filters, "roles", $$v)
      },
      expression: "filters.roles"
    }
  }, _vm._l((_vm.roleoptions), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.rolename,
        "value": item.roleid
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "select",
    staticStyle: {
      "display": "flex",
      "width": "20%"
    },
    attrs: {
      "label": "所属店铺："
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "90%"
    },
    attrs: {
      "filterable": "",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.ListBbid),
      callback: function($$v) {
        _vm.ListBbid = $$v
      },
      expression: "ListBbid"
    }
  }, _vm._l((_vm.Listjigouoptions), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.Name,
        "value": item.Id
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "display": "flex",
      "width": "20%"
    },
    attrs: {
      "label": "账号状态："
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "90%"
    },
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.caozuo),
      callback: function($$v) {
        _vm.caozuo = $$v
      },
      expression: "caozuo"
    }
  }, _vm._l((_vm.caozuoarr), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.label,
        "value": item.Id
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "danger"
    },
    on: {
      "click": _vm.onSubmit
    }
  }, [_vm._v("查询")])], 1)], 1)], 1)])], 1), _vm._v(" "), _c('div', {
    staticClass: "main_container"
  }, [_c('section', {
    staticClass: "model_section"
  }, [_c('p', {
    staticClass: "model_top_title",
    staticStyle: {
      "width": "58px"
    }
  }, [_vm._v("账号管理")]), _vm._v(" "), (_vm.authority.indexOf('add') > -1) ? _c('el-button', {
    staticStyle: {
      "float": "right",
      "margin": "5px 10px 0 0"
    },
    attrs: {
      "type": "danger",
      "data-btnmark": "add"
    },
    on: {
      "click": function($event) {
        return _vm.showAddEdit('')
      }
    }
  }, [_vm._v("+ 新增")]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "table_container"
  }, [_c('el-table', {
    attrs: {
      "data": _vm.staffList,
      "stripe": "",
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "num",
      "label": "序号",
      "align": "center",
      "width": "60"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.$index + 1))])]
      }
    }], null, false, 2966791042)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "loginname",
      "label": "账号",
      "align": "center",
      "width": "120"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          attrs: {
            "title": scope.row.loginname
          }
        }, [_vm._v(_vm._s(scope.row.loginname))])]
      }
    }], null, false, 231747690)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "username",
      "label": "姓名",
      "align": "center",
      "width": "150"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          attrs: {
            "title": scope.row.username
          }
        }, [_vm._v(_vm._s(scope.row.username))])]
      }
    }], null, false, 913688618)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "phone",
      "label": "手机号",
      "align": "center",
      "width": "130"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          attrs: {
            "title": scope.row.phone
          }
        }, [_vm._v(_vm._s(scope.row.phone))])]
      }
    }], null, false, 2420192938)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "rolename",
      "label": "角色",
      "align": "center",
      "width": "150"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticClass: "spanList",
          attrs: {
            "title": scope.row.rolename
          }
        }, [_vm._v(_vm._s(scope.row.rolename))])]
      }
    }], null, false, 4245139972)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "状态",
      "align": "center",
      "width": "80"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(scope.row.isenabled == 1 ? '禁用' : '启用'))]
      }
    }], null, false, 3472198776)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "lastlogintime",
      "label": "最近登录时间",
      "align": "center",
      "width": "160"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          attrs: {
            "title": scope.row.lastlogintime
          }
        }, [_vm._v(_vm._s(scope.row.lastlogintime))])]
      }
    }], null, false, 3514197162)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "creator",
      "label": "创建人",
      "align": "center",
      "width": "150"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          attrs: {
            "title": scope.row.creator
          }
        }, [_vm._v(_vm._s(scope.row.creator))])]
      }
    }], null, false, 863757482)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "createtime",
      "label": "创建时间",
      "align": "center",
      "width": "160"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          attrs: {
            "title": scope.row.createtime
          }
        }, [_vm._v(_vm._s(scope.row.createtime))])]
      }
    }], null, false, 2384061290)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "remark",
      "label": "备注",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          attrs: {
            "title": scope.row.remark
          }
        }, [_vm._v(_vm._s(scope.row.remark))])]
      }
    }], null, false, 4040229162)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "fixed": "right",
      "width": "320",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return _c('div', {
          staticClass: "action_container"
        }, [(_vm.authority.indexOf('edit') > -1) ? _c('span', {
          staticClass: "handle",
          attrs: {
            "data-btnmark": "edit"
          },
          on: {
            "click": function($event) {
              return _vm.showAddEdit(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "el-icon-edit-outline"
        }), _vm._v("编辑\r\n              ")]) : _vm._e(), _vm._v(" "), (_vm.authority.indexOf('setrole') > -1) ? _c('span', {
          staticClass: "handle",
          attrs: {
            "data-btnmark": "setrole"
          },
          on: {
            "click": function($event) {
              return _vm.setTingJs(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "el-icon-setting",
          attrs: {
            "aria-hidden": "true"
          }
        }), _vm._v("角色设置\r\n              ")]) : _vm._e(), _vm._v(" "), (_vm.authority.indexOf('resetpwd') > -1) ? _c('span', {
          staticClass: "handle",
          attrs: {
            "data-btnmark": "resetpwd"
          },
          on: {
            "click": function($event) {
              return _vm.mimachangzhi(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "el-icon-unlock",
          attrs: {
            "aria-hidden": "true"
          }
        }), _vm._v("重置密码\r\n              ")]) : _vm._e(), _vm._v(" "), (_vm.authority.indexOf('enabledordisable') > -1) ? _c('span', {
          staticClass: "handle",
          attrs: {
            "data-btnmark": "enabledordisable"
          },
          on: {
            "click": function($event) {
              return _vm.cardStatus(scope.row)
            }
          }
        }, [_c('i', {
          class: scope.row.isenabled == 0 ? 'el-icon-circle-close' : 'el-icon-circle-check'
        }), _vm._v("\r\n                " + _vm._s(scope.row.isenabled == 0 ? "禁用" : "启用") + "\r\n              ")]) : _vm._e()])
      }
    }], null, false, 3044463306)
  })], 1), _vm._v(" "), _c('el-pagination', {
    staticStyle: {
      "margin": "10px 0",
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "current-page": _vm.pageIndex,
      "page-size": 10,
      "total": _vm.total
    },
    on: {
      "current-change": _vm.handleCurrentChange
    }
  })], 1)])]) : _c('div', {
    staticClass: "main_container"
  }, [_c('section', {
    staticClass: "model_section"
  }, [_c('p', {
    staticClass: "model_top_title"
  }, [_vm._v("账号管理" + _vm._s(_vm.editFormTtile))])]), _vm._v(" "), _c('el-form', {
    ref: "form",
    attrs: {
      "model": _vm.form,
      "label-width": "120px",
      "rules": _vm.rules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "账　　号：",
      "prop": "dlnumber"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "393px"
    },
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.form.dlnumber),
      callback: function($$v) {
        _vm.$set(_vm.form, "dlnumber", $$v)
      },
      expression: "form.dlnumber"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "姓　　名：",
      "prop": "name"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "393px"
    },
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.form.name),
      callback: function($$v) {
        _vm.$set(_vm.form, "name", $$v)
      },
      expression: "form.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "手 机 号：",
      "prop": "phonenumber"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "393px"
    },
    attrs: {
      "type": "tel",
      "auto-complete": "off",
      "maxlength": "11"
    },
    model: {
      value: (_vm.form.phonenumber),
      callback: function($$v) {
        _vm.$set(_vm.form, "phonenumber", $$v)
      },
      expression: "form.phonenumber"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "性　　别："
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "393px"
    },
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.form.sex),
      callback: function($$v) {
        _vm.$set(_vm.form, "sex", $$v)
      },
      expression: "form.sex"
    }
  }, _vm._l((_vm.sexArr), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.name,
        "value": item.val
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "邮　　箱："
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "393px"
    },
    attrs: {
      "type": "email",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.form.email),
      callback: function($$v) {
        _vm.$set(_vm.form, "email", $$v)
      },
      expression: "form.email"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "所属城市："
    }
  }, [_c('el-cascader', {
    staticStyle: {
      "width": "393px"
    },
    attrs: {
      "placeholder": "请选择城市",
      "options": _vm.csOptions,
      "filterable": "",
      "clearable": ""
    },
    on: {
      "change": _vm.handleChangesscs
    },
    model: {
      value: (_vm.chengshi),
      callback: function($$v) {
        _vm.chengshi = $$v
      },
      expression: "chengshi"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.ptgly != 1 || _vm.csgly != 1 || _vm.qygly != 1),
      expression: "ptgly != 1||csgly != 1||qygly != 1"
    }],
    attrs: {
      "label": "所属店铺："
    }
  }, [_c('el-select', {
    ref: "select",
    staticStyle: {
      "width": "393px"
    },
    attrs: {
      "filterable": "",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.form.BbId),
      callback: function($$v) {
        _vm.$set(_vm.form, "BbId", $$v)
      },
      expression: "form.BbId"
    }
  }, _vm._l((_vm.mechanismList), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "备　　注：",
      "prop": "remark"
    }
  }, [_c('el-input', {
    staticClass: "textarea",
    staticStyle: {
      "width": "393px"
    },
    attrs: {
      "type": "textarea",
      "rows": "3"
    },
    model: {
      value: (_vm.form.remark),
      callback: function($$v) {
        _vm.$set(_vm.form, "remark", $$v)
      },
      expression: "form.remark"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center",
      "margin-bottom": "20px"
    }
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        return _vm.cancelshow()
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "danger"
    },
    on: {
      "click": function($event) {
        return _vm.editBan()
      }
    }
  }, [_vm._v("保 存")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "角色设置",
      "visible": _vm.dialogVisible,
      "width": "680px",
      "height": "422px"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true
    }
  }, [_c('el-form-item', [_c('el-input', {
    staticStyle: {
      "width": "230px"
    },
    attrs: {
      "placeholder": "请输入关键词"
    },
    model: {
      value: (_vm.searchKey),
      callback: function($$v) {
        _vm.searchKey = $$v
      },
      expression: "searchKey"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "danger"
    },
    on: {
      "click": _vm.getSortList
    }
  }, [_vm._v("查询")])], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "danger"
    },
    on: {
      "click": _vm.confirmSetRole
    }
  }, [_vm._v("确定")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    staticClass: "shut"
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('p', [_vm._v("角色列表")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('p', [_vm._v("已选角色")])])], 1), _vm._v(" "), _c('el-row', {
    staticClass: "shuttle"
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "TLeft",
    staticStyle: {
      "width": "50%",
      "float": "left"
    }
  }, _vm._l((_vm.TData), function(val, index) {
    return _c('p', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (val.rolename.indexOf(_vm.tempkey) > -1),
        expression: "val.rolename.indexOf(tempkey)>-1"
      }],
      key: index,
      on: {
        "click": function($event) {
          return _vm.checkImg(val, index)
        }
      }
    }, [(val.ischecked == 0) ? _c('img', {
      staticClass: "left_img",
      attrs: {
        "src": _vm.src1,
        "alt": ""
      }
    }) : _c('img', {
      staticClass: "left_img",
      attrs: {
        "src": _vm.src2,
        "alt": ""
      }
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(val.rolename))])])
  }), 0), _vm._v(" "), _c('el-col', {
    staticClass: "border_r",
    attrs: {
      "span": 12
    }
  }, _vm._l((_vm.TData), function(item, index) {
    return _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.ischecked == 1),
        expression: "item.ischecked==1"
      }],
      key: index,
      staticClass: "TRight"
    }, [_c('p', [_vm._v(_vm._s(item.rolename))]), _vm._v(" "), _c('img', {
      staticClass: "chahao",
      attrs: {
        "src": require("../../assets/img/aicon36.png"),
        "alt": ""
      },
      on: {
        "click": function($event) {
          return _vm.canCheck(item, index)
        }
      }
    })])
  }), 0)], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "提示",
      "visible": _vm.resetpassword,
      "width": "30%"
    },
    on: {
      "update:visible": function($event) {
        _vm.resetpassword = $event
      }
    }
  }, [_c('span', [_vm._v("确定重置当前员工：" + _vm._s(_vm.byphonechange) + " 的用户密码么？")]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    staticClass: "span",
    on: {
      "click": function($event) {
        _vm.resetpassword = false
      }
    }
  }, [_c('span', {
    staticStyle: {
      "margin-left": "-5px",
      "margin-top": "-5px"
    }
  }, [_vm._v("取 消")])]), _vm._v(" "), _c('el-button', {
    staticClass: "span",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.changemima
    }
  }, [_c('span', {
    staticStyle: {
      "margin-left": "-5px",
      "margin-top": "-5px"
    }
  }, [_vm._v("确 定")])])], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6ba91e9a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/system/staff.vue
// module id = 1708
// module chunks = 3